import type { Translations } from './types';

export const en: Translations = {
  appName: 'NATO Alphabet Coach',
  converter: 'Converter',
  quiz: 'Letter Quiz',
  wordQuiz: 'Word Quiz',
  settings: 'Settings',
  enterText: 'Enter text to convert',
  placeholder: 'Type your message here...',
  natoAlphabet: 'NATO Alphabet',
  playPronunciation: 'Play Pronunciation',
  stop: 'Stop',
  quickReference: 'Quick Reference',
  showLess: 'Show Less',
  viewFullAlphabet: 'View Full Alphabet →',
  copied: 'Copied!',
  copyFailed: 'Copy failed',
  speechNotAvailable: 'Speech not available',
  voiceSettings: 'Voice Settings',
  textToSpeechVoice: 'Text-to-Speech Voice',
  testVoice: 'Test Voice',
  notifications: 'Notifications',
  spacedRepetitionReminders: 'Spaced Repetition Reminders',
  notificationDescription: 'Get daily notifications to practice',
  language: 'English',
  interfaceLanguage: 'Interface Language',
  about: 'About NATO Alphabet Coach',
  question: 'Question',
  questionCount: '{current} of {total}',
  reviewYourAnswers: 'Review Your Answers',
  typeNatoWordForLetter: 'Type the NATO word for letter {letter}',
  startVoiceInput: 'Start voice input',
  stopVoiceInput: 'Stop voice input',
  aboutDescription:
    'Learn the NATO phonetic alphabet through interactive quizzes and spaced repetition.',
  version: 'Version 1.0.0',
  builtWith: 'Built with modern web technologies',
  currentStreak: 'Current Streak',
  totalSessions: 'Total Sessions',
  accuracy: 'Accuracy',
  learningProgress: 'Learning Progress',
  startQuiz: 'Start Quiz',
  restartQuiz: 'Restart Quiz',
  nextQuestion: 'Next Question',
  submitAnswer: 'Submit Answer',
  showStats: 'Show Stats',
  hideStats: 'Hide Stats',
  correctAnswer: 'Correct Answer',
  yourAnswer: 'Your Answer',
  correct: 'Correct',
  incorrect: 'Incorrect',
  sessionComplete: 'Session Complete!',
  score: 'Score',
  tryAgain: 'Try Again',
  hint: 'Hint',
  femaleVoice: 'Female Voice',
  maleVoice: 'Male Voice',
  robotVoice: 'Robot Voice',
  dailyReminders:
    "You'll receive daily reminders to practice the NATO alphabet based on your learning progress.",
  speakAnswer: 'Speak your answer',
  voiceInputActive: 'Listening...',
  adaptiveLearning: 'Adaptive Learning',
  spacedRepetitionDescription:
    'Each quiz set of 10 questions adapts based on your performance using spaced repetition.',
  skipQuestion: 'Skip',
  pressEnterToSubmit: 'Press Enter to submit',
  pressEscapeToSkip: 'Press Escape to skip',
  exampleAnswers: 'Example: "Alpha", "Bravo", "Charlie"',
  notificationsPanelTitle: 'Notifications',
  markAllAsRead: 'Mark all as read',
  noNotifications: 'No notifications',
  natoHints: {
    A: 'First letter of Greek alphabet',
    B: 'Well done, applause!',
    C: 'Phonetic C, like the name',
    D: 'River formation triangle',
    E: 'Sound reflection',
    F: 'Ballroom dance',
    G: 'Sport with clubs and holes',
    H: 'Place to stay overnight',
    I: 'Large Asian country',
    J: 'Shakespeare heroine',
    K: 'Unit of weight (1000 grams)',
    L: 'Capital of Peru',
    M: 'Short for microphone',
    N: 'Autumn month',
    O: 'Academy Award',
    P: 'Father, informal',
    Q: 'Canadian province',
    R: 'Shakespeare character',
    S: 'Mountain range',
    T: 'Argentine dance',
    U: 'Same clothing for all',
    V: 'Winner, champion',
    W: 'Strong alcoholic drink',
    X: 'Medical imaging',
    Y: 'American baseball player',
    Z: 'African warrior nation',
  },
  // Quiz specific
  learning: 'Learning',
  review: 'Review',
  mastered: 'Mastered',
  lastFiveTimes: 'Last 5 Quiz Times',
  quizTimes: 'Quiz Times',
  bestTime: 'Best Time',
  noTimesRecorded: 'No Times Recorded',
  // Settings
  theme: 'Theme',
  lightTheme: 'Light',
  darkTheme: 'Dark',
  rainbowTheme: 'Rainbow',
  systemTheme: 'System',
  appearance: 'Appearance',
  chooseTheme: 'Choose your preferred theme',
  speechRate: 'Speech Rate',
  pitch: 'Pitch',
  volume: 'Volume',
  // Custom Word Input
  enterCustomWord: 'Enter Custom Word',
  enterYourWordOrPhrase: 'Enter your word or phrase...',
  useThisWord: 'Use This Word',
  // WordDisplay localization
  currentWordLabel: 'Current Word',
  customWordLabel: 'Custom',
  currentWordSpeech: 'Current word is: {word}',
  difficultyLabels: {
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
  },
  categoryLabels: {
    animals: 'Animals',
    places: 'Places',
    nature: 'Nature',
    technology: 'Technology',
    home: 'Home',
    objects: 'Objects',
    transport: 'Transport',
  },
  // NATO Input specific translations
  natoInputTitle: 'Your NATO Alphabet Input',
  natoInputPlaceholder: 'Enter NATO words: "Alpha Bravo Charlie..."',
  natoInputListening: 'Listening...',
  natoInputLiveScore: 'Live Score',

  // Quiz Header translations
  wordQuizInstructions:
    'Convert the word below to NATO alphabet. Say each NATO word separated by spaces or commas.',

  // Quiz Actions translations
  retry: 'Retry',
  checkAnswer: 'Check Answer',
  newRandomWord: 'New Random Word',
  cancelCustom: 'Cancel Custom',
  customWord: 'Custom Word',

  // Quiz Results translations
  perfect: 'Perfect!',
  results: 'Results',
  expectedNato: 'Expected NATO:',
  play: 'Play',
  letterByLetter: 'Letter by Letter:',
};
